<template>
        <div>
        <div v-if="ctype=='exemption'">
          ({{projected}})
        </div>
        <div v-else>
        {{projected}}
        </div>
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
		  },
		  props: ['employee_id', 'fiscal_year', 'head', 'current_headvalue', 'month', 'type','headtype'],
				 
   
		  data() {
			  
			  return {
				  emp_id: this.employee_id,  
                  fisc_year: this.fiscal_year, 
                  head_title: this.head, 
                  projected:'0',
                  cur_headvalue:this.current_headvalue,
                  mnth:this.month,
                  ctype:this.type,
                  hdtype:this.headtype                  
			  }
		  },
		  
		  methods:{
		  

			  
			  getheadprojectedtotal: function()
			  {
  
						  axios.get(this.$api_url+'/get-head-projectedtaxable/'+this.emp_id+'/'+this.fisc_year+'/'+this.head_title+'/'+this.cur_headvalue+'/'+this.mnth+'/'+this.hdtype , {
							  params: {
								  status: '',
							  }
					  }).then(function(response){
					  this.projected =response.data.projected;
  
  
				  }.bind(this));
			  },
              
              
              failed_request_recovery: function()
			  {
			       if(this.projected=='0')
                   {
                   //alert(1);
                   this.getheadprojectedtotal();
                   }
			  },

			  
  
		  },
		  created: function(){
		  
		     this.getheadprojectedtotal();
             setInterval(this.failed_request_recovery, 4200);

			 	
		  }
	  }
  </script>